import log from 'loglevel';

/**
 * Sets the level on loglevel's process-global singleton — this is not scoped to
 * a logger instance, so the last call wins for the entire process. Call it
 * exactly once, at bootstrap (apps/portfolio-web/src/app/app.tsx does it at
 * module scope so it lands before anything else can log).
 *
 * Note the consequence in production: the level is 'error', so logDebug and
 * logWarn become no-ops. Several callers in services/analytics use logWarn as
 * the only trace of a deliberately swallowed error — in production those
 * failures are silent by design, and anything that must be visible has to go
 * through logError.
 */
const setLogLevel = (env: 'development' | 'production'): void => {
  const currentLevel = env === 'development' ? 'debug' : 'error';

  log.setLevel(currentLevel);
};

const logDebug = (message: string, ...args: unknown[]): void => {
  log.debug(message, ...args);
};

const logWarn = (message: string, ...args: unknown[]): void => {
  log.warn(message, ...args);
};

const logError = (message: string, ...args: unknown[]): void => {
  log.error(message, ...args);
};

export { setLogLevel, logDebug, logError, logWarn };
